export default __webpack_public_path__ + "static/media/maintenance-icon.4bd522ae.png";